export default function slidersInit($) {
    // cart&checkout pages slider

    const $sliderCart = $(".wa-main-cart__accesories__slider");

    if ($sliderCart.length) {
        $sliderCart.slick({
            infinite: true,
            slidesToShow: 7,
            slidesToScroll: 1,
            autoplay: true,
            prevArrow: $(".slider-prev-arrow.active-slider"),
            nextArrow: $(".slider-next-arrow.active-slider"),
            responsive: [
                {
                    breakpoint: 720,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    }

    const $sliderSingleProduct = $(".single-product__accessory-slider.active-slider");

    if ($sliderSingleProduct.length) {
        $sliderSingleProduct.slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            prevArrow: $(".slider-prev-arrow.active-slider"),
            nextArrow: $(".slider-next-arrow.active-slider"),
            responsive: [
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 620,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 380,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
}
